import type { IconSvgObject } from './types';

const WaypointsIcon: IconSvgObject = [
  ["circle", { cx: "19", cy: "5", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "5", cy: "19", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 11.5C5.81753 10.952 5 9.77629 5 8.41428C5 6.52863 6.567 5 8.5 5H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M10 19H15.5C17.433 19 19 17.4714 19 15.5857C19 14.2237 18.1825 13.048 17 12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default WaypointsIcon;
